import FetchStatusRepository   from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository        from "../../../domain/fundamentals/message/notify/NotifyRepository";
import Staff                   from "../../../domain/staff/Staff";
import StaffRepository         from "../../../domain/staff/StaffRepository";
import FetchStatusDataSource   from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource        from "../../../infrastructure/datasource/notify/NotifyDataSource";
import StaffDataSource         from "../../../infrastructure/datasource/staff/StaffDataSource";
import GetAccount              from "../authentication/GetAccount";
import SetValidateErrorMessage from "../error/SetValidateErrorMessage";

class UpdateStaffOnAccount {
  private readonly repository: StaffRepository = new StaffDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly setValidateErrorMessage: SetValidateErrorMessage = new SetValidateErrorMessage(this.dispatch);
  private readonly getAccount: GetAccount = new GetAccount(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(staff: Staff, callback: (value: boolean) => void) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.update(staff);
      await this.getAccount.execute();
      this.notifyRepository.saveSuccess();
      callback(false);
    } catch (e) {
      this.setValidateErrorMessage.execute(e);
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default UpdateStaffOnAccount;
